import { colors } from '@/theme';
import { alpha } from '@mui/material/styles';

export const chatbotStyles = {
  // Root container
  container: {
    position: 'fixed',
    bottom: 24,
    right: 24,
    zIndex: 1300,
  },

  // Chat window (Paper)
  chatWindow: {
    position: 'absolute',
    bottom: 72,
    right: 0,
    width: { xs: 'calc(100vw - 32px)', sm: 400 },
    maxWidth: 400,
    height: { xs: 420, sm: 480 },
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 3,
    overflow: 'hidden',
  },

  // Header
  header: {
    bgcolor: colors.primary.main,
    color: '#fff',
    px: 2,
    py: 1.5,
    display: 'flex',
    alignItems: 'center',
    gap: 1.5,
    flexShrink: 0,
  },

  // Header avatar
  headerAvatar: {
    bgcolor: '#fff',
    color: colors.primary.main,
    width: 36,
    height: 36,
  },

  // Header avatar icon
  headerAvatarIcon: {
    fontSize: 22,
  },

  // Header title
  headerTitle: {
    color: '#fff',
    lineHeight: 1.3,
  },

  // Header subtitle
  headerSubtitle: {
    color: alpha('#fff', 0.8),
    lineHeight: 1.2,
  },

  // Close button
  closeButton: {
    color: '#fff',
  },

  // Messages area
  messagesArea: {
    flex: 1,
    overflowY: 'auto',
    px: 2,
    py: 1.5,
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    bgcolor: colors.grey[50],
    '&::-webkit-scrollbar': { width: 4 },
    '&::-webkit-scrollbar-thumb': {
      bgcolor: colors.grey[300],
      borderRadius: 2,
    },
  },

  // Message row
  messageRow: (isUser: boolean) => ({
    display: 'flex',
    justifyContent: isUser ? 'flex-end' : 'flex-start',
  }),

  // Message bubble
  messageBubble: (isUser: boolean) => ({
    maxWidth: '80%',
    px: 1.5,
    py: 1,
    borderRadius: 2,
    bgcolor: isUser ? colors.primary.main : '#fff',
    color: isUser ? '#fff' : colors.grey[800],
    fontSize: '0.85rem',
    lineHeight: 1.5,
    boxShadow: isUser ? 'none' : `0 1px 3px ${alpha(colors.grey[400], 0.3)}`,
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
  }),

  // Typing indicator
  typingIndicator: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
  },

  // Typing spinner
  typingSpinner: {
    color: colors.primary.main,
  },

  // Typing text
  typingText: {
    color: colors.grey[500],
  },

  // Input area
  inputArea: {
    px: 1.5,
    py: 1,
    borderTop: `1px solid ${colors.grey[200]}`,
    bgcolor: '#fff',
    flexShrink: 0,
  },

  // Input field
  inputField: {
    fontSize: '0.85rem',
    borderRadius: 2,
  },

  // Send button
  sendButton: {
    color: colors.primary.main,
  },

  // FAB button
  fab: (isOpen: boolean) => ({
    bgcolor: colors.primary.main,
    '&:hover': { bgcolor: colors.primary.dark },
    width: 52,
    height: 52,
    boxShadow: `0 4px 14px ${alpha(colors.primary.main, 0.4)}`,
    ...(!isOpen && {
      animation: 'pulse 2s ease-in-out infinite',
      '@keyframes pulse': {
        '0%': {
          boxShadow: `0 4px 14px ${alpha(colors.primary.main, 0.4)}`,
        },
        '50%': {
          boxShadow: `0 4px 20px ${alpha(colors.primary.main, 0.6)}, 0 0 0 8px ${alpha(colors.primary.main, 0.15)}`,
        },
        '100%': {
          boxShadow: `0 4px 14px ${alpha(colors.primary.main, 0.4)}`,
        },
      },
    }),
    '& .chat-icon': {
      animation: !isOpen ? 'bounce 2s ease-in-out infinite' : 'none',
      '@keyframes bounce': {
        '0%, 100%': { transform: 'translateY(0)' },
        '50%': { transform: 'translateY(-3px)' },
      },
    },
  }),
};
